import React from "react";
import Cookies from "js-cookie";
import Client from "shopify-buy";
import cookie from "../../utils/cookie.json";
import Discount from "../../utils/discount";
let DISCOUNT = new Discount();

const client = Client.buildClient({
  domain: "store.drinkyogaflow.com",
  storefrontAccessToken: "50ad06d768e2ba0eadfce5bda1608413"
});

import Bus from "../../utils/bus";
let BUS = new Bus();

import CartLineItem from "./cart-line-item";

class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collection: null,
      checkout: null,
      canInteract: false,
      discount: DISCOUNT.amount(),
      cookie: cookie.discount_cookie,
      cartId: cookie.cart_id
    };
    this.addToCart = this.addToCart.bind(this);
    this.removeFromCart = this.removeFromCart.bind(this);
    this.findLineItemFromVariant = this.findLineItemFromVariant.bind(this);
    this.clearCart = this.clearCart.bind(this);
    this.addToCartInput = this.addToCartInput.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.addFromCta = this.addFromCta.bind(this);
    this.proceedToCheckout = this.proceedToCheckout.bind(this);
    this.trackAddToCart = this.trackAddToCart.bind(this);
    this.addCookieDiscount = this.addCookieDiscount.bind(this);
  }

  componentDidMount() {
    if (client) {
      const collectionId = "Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzQ2ODg0NzgyMTI0";
      client.collection.fetchWithProducts(collectionId).then(collection => {
        this.setState(
          {
            collection: collection,
            canInteract: true
          },
          () => BUS.listen("ADD_FROM_CTA", this.addFromCta)
        );
      });
    }
    if (Cookies.get(this.state.cartId) === undefined) {
      client.checkout.create().then(checkout => {
        Cookies.set(this.state.cartId, checkout.id, { expires: 2 });
        this.setState({
          checkout: checkout,
          canInteract: true
        });
        if (Cookies.get(this.state.cookie)) {
          this.addCookieDiscount(checkout.id, checkout);
        }
      });
    } else {
      const ww_cart_id = Cookies.get(this.state.cartId);
      client.checkout.fetch(ww_cart_id).then(checkout => {
        if (checkout.completedAt !== null) {
          Cookies.remove(this.state.cartId);
          //window.location.href = window.location;
        }
        if (DISCOUNT.amount() !== 0) {
          this.addCookieDiscount(ww_cart_id, this.state.checkout);
        }
        BUS.listen("DISCOUNT_APPLIED", () => {
          this.addCookieDiscount(ww_cart_id, this.state.checkout);
        });

        this.setState(
          {
            checkout: checkout,
            canInteract: true
          },
          () => BUS.trigger("UPDATE_CART", { data: checkout })
        );
      });
    }
    BUS.listen("ADD_FROM_SHOP", this.addFromCta);
  }

  addCookieDiscount(cartId, checkout) {
    this.setState({
      discount: 0.2
    });
    BUS.trigger("DISCOUNT_APPLIED");
    client
      ? client.checkout.addDiscount(cartId, "20OFF").then(checkout => {
          this.setState({ checkout: checkout });
        })
      : null;
  }

  addFromCta(event) {
    const product = this.state.collection.products.find(item => {
      return event.detail === item.variants[0].id;
    });
    const variantId = product.variants[0].id;
    this.addToCart(event, variantId);
    // BUS.trigger("OPEN_CART");
  }

  handleCartUpdate(e, variantId) {
    this.setState({ canInteract: false });
    const checkForLineId = this.findLineItemFromVariant(variantId);

    if (checkForLineId === undefined) this.addToCart(e, variantId);
    else this.addToCartInput(e, checkForLineId.id);
  }

  addToCart(e, variantId) {
    this.setState({ canInteract: false });
    if (this.state.checkout) {
      const checkoutId = this.state.checkout.id;
      const lineItemsToAdd = [
        {
          variantId,
          quantity: Number(e.target.value) || 1
        }
      ];

      client.checkout
        .addLineItems(checkoutId, lineItemsToAdd)
        .then(checkout => {
          this.setState(
            {
              checkout: checkout,
              canInteract: true
            },
            () => BUS.trigger("UPDATE_CART", { data: checkout })
          );
          this.trackAddToCart(variantId);
        })
        .catch(error => {
          console.log("addToCart error", error);
        });
    }
  }

  addToCartInput(e, lineItemId) {
    if (this.state.checkout) {
      const checkoutId = this.state.checkout.id;

      const lineItemsToUpdate = {
        quantity: Number(e.target.value),
        id: lineItemId
      };
      client.checkout
        .updateLineItems(checkoutId, lineItemsToUpdate)
        .then(checkout => {
          this.setState({
            checkout: checkout,
            canInteract: true
          });
        });
    }
  }

  removeFromCart(variantId) {
    let lineItemId = this.findLineItemFromVariant(variantId);
    if (this.state.checkout) {
      if (lineItemId === undefined) {
        return;
      } else {
        this.setState({ canInteract: false });
        const updatedQuantity = lineItemId.quantity - 1;
        const lineItemsToUpdate = [
          {
            id: lineItemId.id,
            quantity: updatedQuantity
          }
        ];
        const checkoutId = this.state.checkout.id;
        client.checkout
          .updateLineItems(checkoutId, lineItemsToUpdate)
          .then(checkout => {
            this.setState(
              {
                checkout: checkout,
                canInteract: true
              },
              () => BUS.trigger("UPDATE_CART", { data: checkout })
            );
          });
      }
    }
  }

  clearCart(variantId) {
    if (this.state.checkout) {
      const checkoutId = this.state.checkout.id;
      const varId = this.findLineItemFromVariant(variantId);
      client.checkout.removeLineItems(checkoutId, varId).then(checkout => {
        this.setState({ checkout: checkout });
      });
    }
  }

  findLineItemFromVariant(variantId) {
    return this.state.checkout.lineItems.find((lineItem, i) => {
      if (lineItem.variant.id === variantId) {
        return lineItem.id;
      } else return undefined;
    });
  }

  proceedToCheckout(event) {
    event.preventDefault();
    BUS.trigger("TRACK_CART", {
      data: {
        value: Number(this.state.checkout.totalPrice),
        category: "User",
        action: "Proceed To Checkout"
      }
    });
    let cartUrl = this.checkoutBtn.getAttribute("href");
    setTimeout(() => {
      if (window !== undefined) {
        window.location.href = cartUrl;
      }
    }, 300);
  }

  trackAddToCart(variantId) {
    const product = this.state.checkout.lineItems.find(item => {
      return variantId === item.variant.id;
    });
    BUS.trigger("TRACK_PRODUCT", { title: product.title });
  }

  render() {
    return (
      <div className="Cart">
        {this.state.collection &&
          this.state.checkout &&
          this.state.collection.products.map((product, i) => {
            return (
              <CartLineItem
                product={product}
                index={i}
                key={i}
                discount={this.state.discount}
                handleCartUpdate={this.handleCartUpdate}
                addItem={this.addToCart}
                removeFromCart={this.removeFromCart}
                checkout={this.state.checkout}
                clearCart={this.clearCart}
                location={this.props.location}
              />
            );
          })}
        {!this.state.canInteract && <div className="no-interact" />}
        {this.state.collection &&
          this.state.checkout && (
            <div className="total-checkout">
              {this.state.discount !== 0 && (
                <div className="discount-message">
                  {this.state.discount * 100}% discount has be applied!
                </div>
              )}

              {this.state.checkout.totalPrice === "0.00" && (
                <div>
                  <span className="price size--m">Your cart is empty</span>
                  <span className="shipping size--s light">
                    All prices are in USD & excludes shipping, to be calculated
                    at the next step.
                  </span>
                </div>
              )}

              {this.state.checkout.totalPrice !== "0.00" && (
                <div>
                  <span className="price size--m">
                    Cart total: ${this.state.checkout.totalPrice}
                  </span>
                  <span className="shipping size--s light">
                    All prices are in USD & excludes shipping, calculated at the
                    next step.
                  </span>

                  <a
                    className="checkout Btn brown-white"
                    href={this.state.checkout.webUrl}
                    ref={el => {
                      this.checkoutBtn = el;
                    }}
                    target="_blank"
                    onClick={this.proceedToCheckout}
                  >
                    Proceed to checkout
                  </a>
                </div>
              )}
            </div>
          )}
      </div>
    );
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/components/cart/cart.js